var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('SurfacePanelPostExpandedAttachment',{ref:"attachment",attrs:{"dark-mode":_vm.darkMode,"display-attributes":_vm.displayAttributes,"safe-area":_vm.safeArea}})
}
var staticRenderFns = []

export { render, staticRenderFns }